var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47106 12.2428L7.52825 13.1856C6.2265 14.4873 4.11595 14.4873 2.8142 13.1856C1.51245 11.8838 1.51245 9.77329 2.8142 8.47154L3.75701 7.52874M12.2423 8.47154L13.1851 7.52874C14.4868 6.22699 14.4868 4.11644 13.1851 2.81469C11.8834 1.51294 9.7728 1.51294 8.47106 2.81469L7.52825 3.7575M5.66632 10.3335L10.333 5.66679",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8e50e4c754ee086abb63ddaaedbfc107.svg";
export { ForwardRef as ReactComponent };